import type {PinIdentifier, PinPaymentRegion} from '../../../types';

import {DeleteOutlined, EnvironmentOutlined} from '@ant-design/icons';
import {dateToReadableDate} from '@date-picker';
import {IconButton} from '@ds/components';
import {numberFormat} from 'utils/Helper';

type PinPackageGroupsProps = {
  regions: PinPaymentRegion[];
  mode: 'basket' | 'payment-success';
  onRemove?: (pinId: PinIdentifier) => void;
  removingPinId?: PinIdentifier;
};

const PinPackageGroups: React.FC<PinPackageGroupsProps> = ({
  regions,
  mode,
  onRemove,
  removingPinId
}) => {
  return (
    <div className="flex flex-col">
      {regions.map((region) => (
        <section className="mt-5 flex flex-col first:mt-0" key={region.name}>
          <h2 className="flex items-center gap-2.5 px-2.5 text-body-sm-emphasis text-gray-07">
            <EnvironmentOutlined aria-hidden />
            <span>{region.name}</span>
          </h2>
          <div className="flex flex-col">
            {region.items.map((item, index) => {
              const date = mode === 'basket' ? item.activate_date : item.active_date;

              return (
                <div
                  className="flex items-center justify-between gap-3 border-b border-gray-03 p-2.5 text-body-sm-emphasis last:border-b-0"
                  key={item.id ?? `${date}-${index}`}
                >
                  <span className="text-neutral-fg">
                    {dateToReadableDate({date: date ?? '', day: true, month: true})}
                  </span>
                  {mode === 'basket' ? (
                    <div className="flex items-center gap-2">
                      <span className="text-neutral-fg">
                        {numberFormat(item.discounted_price ?? 0)} تومان
                      </span>
                      {onRemove ? (
                        <IconButton
                          aria-label="حذف بسته"
                          size="md"
                          color="destructive"
                          disabled={item.id == null || removingPinId === item.id}
                          onClick={() => {
                            if (item.id != null) {
                              onRemove(item.id);
                            }
                          }}
                        >
                          <DeleteOutlined aria-hidden />
                        </IconButton>
                      ) : null}
                    </div>
                  ) : (
                    <div className="flex items-center gap-2 text-neutral-fg">
                      {!item.discount ? <span>{numberFormat(item.price ?? 0)} تومان</span> : null}
                      {item.percentage ? (
                        <span className="rounded-md bg-destructive px-1.5 text-destructive-on">
                          {item.percentage}%
                        </span>
                      ) : null}
                      {item.discount ? (
                        <>
                          <span className="text-gray-04 line-through">
                            {numberFormat(item.discount)}
                          </span>
                          <span>{numberFormat(item.price ?? 0)} تومان</span>
                        </>
                      ) : null}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
};

export default PinPackageGroups;
